(() => {
  if (window.eneaMediaLoadingInstalled) return;
  window.eneaMediaLoadingInstalled = true;
  const touchLayout = window.matchMedia('(any-pointer: coarse), (max-width: 767px)');
  const cards = new WeakSet();
  const preparedCards = new WeakSet();
  const videos = new WeakSet();
  const imageSelector = 'img[data-enea-src]';
  const videoSelector = 'video[data-enea-autoplay]';
  const loadImages = card => {
    preparedCards.add(card);
    card.querySelectorAll(imageSelector).forEach(img => {
      img.loading = 'eager';
      if (img.dataset.eneaSrcset) {
        img.srcset = img.dataset.eneaSrcset;
        delete img.dataset.eneaSrcset;
      }
      img.src = img.dataset.eneaSrc;
      delete img.dataset.eneaSrc;
    });
  };
  const onScreen = video => {
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < window.innerHeight && rect.left < window.innerWidth &&
      !video.closest('[hidden]') && document.visibilityState === 'visible';
  };
  const play = video => {
    if (!onScreen(video) || video.querySelector('source[data-enea-video-src]')) return;
    const attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(() => {});
  };
  const loadVideo = video => {
    const sources = video.querySelectorAll('source[data-enea-video-src]');
    if (!sources.length) return;
    video.muted = true;
    video.playsInline = true;
    sources.forEach(source => {
      source.src = source.dataset.eneaVideoSrc;
      delete source.dataset.eneaVideoSrc;
    });
    video.load();
    play(video);
  };
  const supported = 'IntersectionObserver' in window;
  const cardObserver = supported ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && touchLayout.matches) {
        loadImages(entry.target);
        cardObserver.unobserve(entry.target);
      }
    });
  }, {rootMargin: '300px 0px'}) : null;
  const videoLoader = supported ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadVideo(entry.target);
        videoLoader.unobserve(entry.target);
      }
    });
  }, {rootMargin: '250px 0px'}) : null;
  const videoPlayer = supported ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadVideo(entry.target);
        play(entry.target);
      } else {
        entry.target.pause();
      }
    });
  }, {threshold: 0.01}) : null;
  const scan = root => {
    const matches = selector => [
      ...(root.matches && root.matches(selector) ? [root] : []),
      ...root.querySelectorAll(selector)
    ];
    matches('.product-grid-item').forEach(card => {
      if (cards.has(card) || !card.querySelector(imageSelector)) return;
      cards.add(card);
      const prepare = () => loadImages(card);
      card.addEventListener('pointerenter', prepare, {once: true, passive: true});
      card.addEventListener('focusin', prepare, {once: true});
      card.addEventListener('touchstart', prepare, {once: true, passive: true, capture: true});
      card.addEventListener('pointerdown', prepare, {once: true, passive: true, capture: true});
      if (cardObserver) cardObserver.observe(card);
      else prepare();
    });
    matches(videoSelector).forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.addEventListener('loadeddata', () => play(video));
      if (videoLoader) {
        videoLoader.observe(video);
        videoPlayer.observe(video);
      } else loadVideo(video);
    });
  };
  const start = () => {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          scan(node);
          const card = node.closest('.product-grid-item');
          if (card && preparedCards.has(card)) loadImages(card);
          else if (card && !cards.has(card)) scan(card);
        }
      }));
    }).observe(document.body, {childList: true, subtree: true});
    touchLayout.addEventListener('change', () => {
      document.querySelectorAll('.product-grid-item').forEach(card => {
        if (cardObserver && card.querySelector(imageSelector)) cardObserver.observe(card);
      });
    });
    document.addEventListener('visibilitychange', () => {
      document.querySelectorAll(videoSelector).forEach(video => {
        if (document.hidden) video.pause();
        else play(video);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
